import React from "react";
import { useSelector } from "react-redux";
import {
  selectIsMenuBtnClicked,
  selectIsSearchBtnClicked,
} from "../NavBar/NavBarSlice.js";
import "./SideBar.css";

import { MenuBar } from "../MenuBar/MenuBar.js";
import { SearchBar } from "../SearchBar/SearchBar.js";

export const SideBar = () => {
  const isMenuBtnClicked = useSelector(selectIsMenuBtnClicked);

  const isOpenSideBar = isMenuBtnClicked;



  return (
    <div
      className={`sideBarContainer ${
        isOpenSideBar ? "sideBarOpen" : "sideBarHidden"
      }`}
    >
      <SearchBar/>
      <MenuBar/>
      <ContactBar/>
    </div>
  );
};

export const ContactBar = () => {

  //Style Below
  const styleContactBarContainer = {
    boxSizing: "border-box",
    width: "40vw",
    color: "#fff",
    position: "absolute",
    bottom: "10vh",
    padding: "0px 4vw",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "5px",
    fontSize: "2vw"
  }

  const styleLineIcon = {
    position: "relative",
    top: "50%",
    display: "flex",
    alignItems: "center",
    width: "100%"
  };

  return (
    <div className="contactBarContainer" style={styleContactBarContainer}>
      <div className="lineIcon" style={styleLineIcon}>
        <svg
          preserveAspectRatio="none"
          viewBox="0 0 450 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
        >
          <path d="M0 0L450 3.93402e-05" stroke="white" strokeWidth={5} />
        </svg>
      </div>
      <a><span>CONTACT</span></a>
    </div>
  )
}